/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.ApiResponse, (_params: vp.IFrameEventRequest) => void, () => void];

function usePostIFrameEvent({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [params, setParams] = useState<vp.IFrameEventRequest>();
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const { t } = useTranslation('translations', { keyPrefix: 'Common' });
  useEffect(() => {
    const sendRequest = async (requestParams: vp.IFrameEventRequest) => {
      setDataFetchingInfo(true, `${t('defaultLoading')}`, 'fullScreen');

      const res = await api.postIFrameEvent(requestParams, source);

      setResponse(res);
      setDataFetchingInfo(false);
      setSendRequest(false);
      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: vp.IFrameEventRequest) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostIFrameEvent);
